export { default as ITeroProposalNotification } from './ITeroProposalNotification';
export { ITeroProposalNotificationModal } from './ITeroProposalNotificationModal';
export * as Styled from './ITeroProposalNotificationModal.styles';
